// Version : 0.0.1
// Author : SABARI

const TransferBranchTypes = {
	/************** CREATE DUPLICATE CENTER GROUP START ******************/
	CREATE_DUPLICATE_CENTER_GROUP_START: 'create_duplicate_center_group_start',
	CREATE_DUPLICATE_CENTER_GROUP_SUCCESS: 'create_duplicate_center_group_sucess',
	CREATE_DUPLICATE_CENTER_GROUP_FAILURE: 'create_duplicate_center_group_failure',
	CREATE_DUPLICATE_CENTER_GROUP_RESPONSE_RESET_START:
		'create_duplicate_center_group_response_reset_start',
	CREATE_DUPLICATE_CENTER_GROUP_RESPONSE_CHANGED:
		'create_duplicate_center_group_response_changed',
	/************** CREATE DUPLICATE CENTER GROUP END ******************/

	/************** MEMBER BRANCH TO CENTER TRANSFER START ******************/
	MEMBER_BRANCH_TO_CENTER_TRANSAFER_START: 'member_branch_to_center_transafer_start',
	MEMBER_BRANCH_TO_CENTER_TRANSAFER_SUCESS: 'member_branch_to_center_transafer_sucess',
	MEMBER_BRANCH_TO_CENTER_TRANSAFER_FALIURE: 'member_branch_to_center_transafer_faliure',
	MEMBER_BRANCH_TO_CENTER_TRANSAFER_RESPONSE_RESET_START:
		'member_branch_to_center_transafer_response_reset_start',
	MEMBER_BRANCH_TO_CENTER_TRANSAFER_RESPONSE_CHNAGED:
		'member_branch_to_center_transafer_reponse_chnaged',
	/************** MEMBER BRANCH TO CENTER TRANSFER END  ******************/

	/************** TRANSFER MEMBER LIST START ******************/
	TRANSFER_MEMBER_LIST_START: 'transfer_member_list_start',
	TRANSFER_MEMBER_LIST_SUCCESS: 'transfer_member_list_success',
	TRANSFER_MEMBER_LIST_FAILURE: 'transfer_member_list_failure',
	TRANSFER_MEMBER_LIST_RESPONSE_RESET_START: 'transfer_member_list_response_reset_start',
	TRANSFER_MEMBER_LIST_RESPONSE_CHANGED: 'transfer_member_list_response_changed',
	/************** TRANSFER MEMBER LIST END ******************/

	/************** FETCH TRANSFER CENTER LIST START ******************/
	FETCH_TRANSFER_CENTER_LIST_START: 'fetch_transfer_center_list_start',
	FETCH_TRANSFER_CENTER_LIST_SUCCESS: 'fetch_transfer_center_list_success',
	FETCH_TRANSFER_CENTER_LIST_FAILURE: 'fetch_transfer_center_list_failure',
	FETCH_TRANSFER_CENTER_LIST_RESPONSE_RESET_START:
		'fetch_transfer_center_list_response_reset_start',
	FETCH_TRANSFER_CENTER_LIST_RESPONSE_CHANGED: 'fetch_transfer_center_list_response_changed',
	/************** FETCH TRANSFER CENTER LIST END ******************/
};

export default TransferBranchTypes;
